module.exports = __webpack_public_path__ + "img/top_black2@2x.a957c466.png";